/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action, computed } from '@ember/object';
import UserModel from 'cio/models/user';
import AuthService from 'cio/services/auth';
import { tracked } from '@glimmer/tracking';
import searchByProperty from 'cio/utils/search-by-property';
import { sortByCaseInsensitive } from 'cio/utils/sort';

interface SettingsEditWorkspaceUsersArgs {
  users: UserModel[];
  selectedUsers: UserModel[];
  onChange: (users: UserModel[]) => unknown;
}

const ENABLE_SEARCH_AFTER = 5;

export default class SettingsEditWorkspaceUsers extends Component<SettingsEditWorkspaceUsersArgs> {
  @service auth!: AuthService;

  @tracked searchTerm = '';

  get searchEnabled() {
    return this.users.length > ENABLE_SEARCH_AFTER;
  }

  @computed('args.selectedUsers.length', 'args.users.length')
  get allSelected() {
    return this.args.selectedUsers.length === this.args.users.length;
  }

  @computed('users.@each.{role,lastName,firstName}')
  get users() {
    let users = sortByCaseInsensitive(this.args.users.toArray(), ['lastName', 'firstName', 'role']);

    if (this.auth.hasPermission('account/team_members/view')) {
      return users;
    } else {
      return users.filter((user) => this.args.selectedUsers.includes(user));
    }
  }

  get filteredUsers() {
    return searchByProperty(this.users, ['fullName', 'email'], this.searchTerm.trim());
  }

  // TODO: Figure out how this related to permissions (if at all)
  get areAllUsersAdmins() {
    return this.users.every((user) => user.isAdmin);
  }

  @action
  toggleAllUsers() {
    let { users } = this.args;

    if (this.allSelected) {
      this.args.onChange(users.filter((user) => user.isAdmin));
    } else {
      this.args.onChange(users);
    }
  }

  @action
  toggleUserAccess(user: UserModel) {
    let { selectedUsers } = this.args;
    let users: UserModel[];

    if (selectedUsers.includes(user)) {
      users = selectedUsers.filter((u) => u.id !== user.id);
    } else {
      users = [...selectedUsers, user];
    }

    this.args.onChange(users);
  }
}
